import { createContext, useContext, useState, useMemo } from 'react';

const FYContext = createContext();

export function FYProvider({ children }) {
  const now = new Date();
  const currentFYStart = now.getMonth() >= 3 ? now.getFullYear() : now.getFullYear() - 1;
  const [selectedFY, setSelectedFY] = useState(currentFYStart);

  const value = useMemo(() => {
    const fyStartDate = `${selectedFY}-04-01`;
    const fyEndDate = `${selectedFY + 1}-03-31`;
    const shortLabel = `FY ${String(selectedFY).slice(2)}-${String(selectedFY + 1).slice(2)}`;
    return { selectedFY, setSelectedFY, fyStartDate, fyEndDate, shortLabel, currentFYStart };
  }, [selectedFY, currentFYStart]);

  return <FYContext.Provider value={value}>{children}</FYContext.Provider>;
}

export function useFY() {
  return useContext(FYContext);
}

// Helper: format YYYY-MM-DD to DD/MM/YYYY
export function formatDateDMY(dateStr) {
  if (!dateStr) return '';
  const [y, m, d] = dateStr.split('-');
  return `${d}/${m}/${y}`;
}

// Helper: validate if a date string (YYYY-MM-DD) falls within the selected FY
export function isDateInFY(dateStr, fyStartYear) {
  if (!dateStr || !fyStartYear) return true;
  const fyStart = `${fyStartYear}-04-01`;
  const fyEnd = `${fyStartYear + 1}-03-31`;
  return dateStr >= fyStart && dateStr <= fyEnd;
}

// Helper: get FY date validation error message in DD/MM/YYYY format
export function getFYDateError(fyStartYear, fyLabel) {
  const start = formatDateDMY(`${fyStartYear}-04-01`);
  const end = formatDateDMY(`${fyStartYear + 1}-03-31`);
  return `Date must be within ${fyLabel} (${start} to ${end})`;
}

// Helper: get FY label from start year
export function getFYLabel(startYear) {
  return `FY ${String(startYear).slice(2)}-${String(startYear + 1).slice(2)}`;
}

// Helper: get list of FY options (last 5 years up to current)
export function getFYOptions(currentFYStart) {
  const options = [];
  for (let y = currentFYStart; y >= currentFYStart - 4; y--) {
    options.push({
      value: y,
      label: `FY ${String(y).slice(2)}-${String(y + 1).slice(2)}`,
      range: `Apr ${y} - Mar ${y + 1}`
    });
  }
  return options;
}
